import type { Job } from '@core/types';

function triggerDownload(blob: Blob, filename: string) {
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
}

function csvEscapeCell(v: string): string {
  if (/[,"\r\n]/.test(v)) return `"${v.replace(/"/g, '""')}"`;
  return v;
}

export function downloadJobsCsv(rows: Job[], appsByJob: Record<string, number>) {
  const headers = ['id', 'title', 'client', 'status', 'publish_status', 'applications', 'location', 'created_at'];
  const headerLine = headers.join(',');
  const lines = rows.map((j) => {
    const cells = [
      j.id,
      j.title ?? '',
      j.client?.name ?? '',
      j.status ?? '',
      j.publish_status ?? '',
      String(appsByJob[j.id] ?? 0),
      j.location ?? '',
      j.created_at ?? '',
    ];
    return cells.map((x) => csvEscapeCell(String(x))).join(',');
  });
  const content = '\ufeff' + [headerLine, ...lines].join('\n');
  const stamp = new Date().toISOString().slice(0, 10);
  const blob = new Blob([content], { type: 'text/csv;charset=utf-8' });
  triggerDownload(blob, `jobs-${stamp}.csv`);
}
